<!-- 点击框框上传图片 -->
<template>
    <div class="uploadFile">
        <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :data="uploadData"
            :action="url"
            :headers="headerObj"
            :on-success="uploadSuccess"
            :before-upload="beforeUpload"
            :on-error="uploadErr"
            accept="image/*"
            list-type="picture-card"
            :file-list="fileList"
        >
            <img v-if="imageUrl" :src="downloadUrl + imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
    </div>
</template>
<script>
export default {
  name: "uploadFile",
  components: {},
  props: {
    pjIndex: {
      type: Number
    },
    defaultImg: { type: String },
    type: {
      type: String
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      imageUrl: this.defaultImg,
      downloadUrl: this.$util.QN_URL_BASE,
      fileList: [],
      url: "/api/UploadFile/UploadSingle",
      headerObj: {
            'access-key': userMsg.Token,
            reqApp: 'yqgPC'
      },       
      uploadData: {
        key: this.type,
        isPrivate: false
      },
    };
  },
  mounted() {},
  methods: {
    uploadSuccess(res) {
      this.imageUrl = res.fileUrl;
      this.$emit("uploadSuccess", res.fileUrl, this.pjIndex);
    },
    uploadErr() {
      this.$util.errorMsg("上传失败");
    },
    beforeUpload(file) {
      return this.$util.uploadCheck(file);
    },
    clearData() {
      this.fileList = [];
      this.havedList = [];
    },
    handleRemove(file, index) {
      let _file;
      if (file.response) {
        _file = file.response.fileUrl;
        this.$emit("handleRemove", _file);
      } else {
        _file = file.ImgUrl;
        this.$emit("handleRemove", _file);
        this.havedList.splice(index, 1);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>
<style lang="less">
.uploadFile {
  .el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 80px;
  }
}
</style>
